// extracted by mini-css-extract-plugin
export default {"wrapper":"Xs2NknLtE07TEktmldZL","label":"JE0AIxCEPYMqiAgbrJJK","pulse":"_JDt9A_xEriZysWliNiH"};